import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logos/tree-crossing-logo-160h.png'
import _imports_1 from '@/assets/tree-crossing-icon-128.png'


const _withScopeId = n => (_pushScopeId("data-v-2b3d38e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "site-header" }
const _hoisted_2 = { class: "container-lg" }
const _hoisted_3 = { class: "left-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "navbar-toggler hide-md",
  "data-bs-toggle": "offcanvas",
  "data-bs-target": "#mainNavDrawer",
  "aria-controls": "mainNavDrawer",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M2.5 11.5A.5.5 0 0 1 3 11h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4A.5.5 0 0 1 3 3h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
    })
  ])
], -1))
const _hoisted_5 = { class: "offcanvas-header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Close"
}, null, -1))
const _hoisted_8 = { class: "offcanvas-body" }
const _hoisted_9 = { class: "navbar-brand show-md" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_12 = { class: "right-group" }
const _hoisted_13 = {
  key: 1,
  type: "button",
  class: "btn btn-primary action",
  "data-bs-toggle": "modal",
  "data-bs-target": "#shareModal"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hide-md" }, "Share", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "show-md" }, "Share my tree", -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/gp/UserStore'
import { LoadMode } from '@/util/AsyncData'
import { Offcanvas } from 'bootstrap'
import { useUploadAction } from './UploadAction'
import { useShareAction } from './ShareAction'
import { Environment } from '@/util/Environment'
import { AsyncUtil } from '@/util/AsyncUtil'
import UserMenu from '@/site/UserMenu.vue'
import SiteNav from './SiteNav.vue'
import SiteSearch from './SiteSearch.vue'
import ShareModal from './ShareModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteHeader',
  setup(__props) {

const hideSignInPages = [
  /^\/signin.*/,
]
const hideGetStartedPages = [
  /^\/signup.*/,
  /^\/signin.*/,
  /^\/groupinvites\/.*\/accept.*/,
]

const showActionsRef = ref(true)

const userStore = useUserStore()
const router = useRouter()
const { showShareActionRef } = useShareAction()
const { showUploadActionInHeaderRef, uploadActionTextRef } = useUploadAction()

const userRef = computed(() => userStore.getAsyncSelf(LoadMode.EnsureLoaded)?.data)
const isHomePageRef = computed(() => router.currentRoute.value.path == '/')
const getStartedClassRef = computed(() => isHomePageRef.value ? 'btn-outline-primary' : 'btn-primary')
const showGetStartedRef = computed(() => !userRef.value && !hideGetStartedPages.some(re => re.test(router.currentRoute.value.path)))
const showSignInRef = computed(() => !userRef.value && !hideSignInPages.some(re => re.test(router.currentRoute.value.path)))

const mainNavDrawerRef = ref<HTMLElement>()
const shareModalRef = ref<InstanceType<typeof ShareModal>>()

onMounted(() => showActionsRef.value = true)

router.afterEach(() => {
  if (mainNavDrawerRef.value) {
    Offcanvas.getOrCreateInstance(mainNavDrawerRef.value)?.hide()
  }
})

async function onSearchFocusOut() {
  // TODO: search should "request" space from header, and header should apply a CSS class to provide it if needed
  await AsyncUtil.delay(500) // wait for search to collapse
  showActionsRef.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", {
      class: _normalizeClass(["navbar navbar-light bg-light sticky-top shadow-sm", { ['dev-only']: _unref(Environment).isDevelopment() }])
    }, [
      _createElementVNode("nav", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            id: "mainNavDrawer",
            ref_key: "mainNavDrawerRef",
            ref: mainNavDrawerRef,
            class: "offcanvas offcanvas-start",
            tabindex: "-1"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(SiteNav, { "as-drawer": "" })
            ])
          ], 512),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _createVNode(SiteNav, { class: "show-md" }),
          (userRef.value)
            ? (_openBlock(), _createBlock(SiteSearch, {
                key: 0,
                class: "show-md",
                onFocusin: _cache[0] || (_cache[0] = ($event: any) => (showActionsRef.value = false)),
                onFocusout: onSearchFocusOut
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["navbar-brand hide-md", { pushed: showActionsRef.value && _unref(showShareActionRef) }])
        }, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", _hoisted_12, [
          (showActionsRef.value && _unref(showUploadActionInHeaderRef))
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: "/syncapp",
                class: "btn btn-primary action"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(uploadActionTextRef)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (showActionsRef.value && _unref(showShareActionRef))
            ? (_openBlock(), _createElementBlock("button", _hoisted_13, _hoisted_16))
            : _createCommentVNode("", true),
          (userRef.value)
            ? (_openBlock(), _createBlock(UserMenu, {
                key: 2,
                class: "user-menu"
              }))
            : (showSignInRef.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 3,
                  class: "nav-link",
                  to: "/signin"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sign in")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
          (showGetStartedRef.value)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                class: _normalizeClass(["btn action", getStartedClassRef.value]),
                to: "/signup"
              }, {
                default: _withCtx(() => [
                  (isHomePageRef.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Sign up")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Get started")
                      ], 64))
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2),
    _createVNode(ShareModal, { id: "shareModal" })
  ]))
}
}

})